import React from 'react';
import TableColumnTitle from '../../../../components/_table/TableColumnTitle';
import TableFilterInput from '../../../../components/_table/TableFilterInput';
import TableFilterSelect from '../../../../components/_table/TableFilterSelect';
import OpenProductDetail from '../../../../components/link/OpenProductDetail';
import OpenReviewDetail from '../../../../components/link/OpenReviewDetail';
import TableColumnImg from '../../../../components/table/TableColumnImg';
import { PRODUCT_STATUS_TEXT } from '../../../../constants/service/app/productConstants';
import {
  TAG_RELATED_ITEM_TYPE_TO_TAG_TAB_MAIN_CONTENTS_TYPE_SELECT_LIST,
  TAG_TAB_MAIN_CONTENTS_TYPE,
  TAG_TAB_MAIN_CONTENTS_TYPE_TEXT,
} from '../../../../constants/service/app/tagConstants';
import { setDateFormat } from '../../../../lib/moment';
import { REVIEW_STATUS_TEXT } from '../../../account/user/detail/AccountUserDetailCsReviewInfo/constants';

/**
 *  태그의 대표 컨텐츠 아이템 컬림
 */
export const columns = (data) => {
  const { isFilter } = data;

  return [
    {
      title: <TableColumnTitle title={'이미지'} />,
      dataIndex: 'url',
      render: (value) => <TableColumnImg url={value} width={'60px'} height={'60px'} />,
    },
    {
      title: <TableColumnTitle title={'종류'} />,
      dataIndex: 'type',
      className: !isFilter && 'not-filter',
      onFilter: (value, record) => record['type'] === Number(value),
      filterDropdown: ({ confirm, setSelectedKeys, clearFilters }) => (
        <TableFilterSelect
          list={TAG_RELATED_ITEM_TYPE_TO_TAG_TAB_MAIN_CONTENTS_TYPE_SELECT_LIST}
          setSelectedKeys={setSelectedKeys}
          clearFilters={clearFilters}
          confirm={confirm}
        />
      ),
      render: (value) => TAG_TAB_MAIN_CONTENTS_TYPE_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'컨텐츠 번호'} />,
      dataIndex: 'contentsId',
      className: !isFilter && 'not-filter',
      onFilter: (value, record) => record['contentsId'] === Number(value),
      filterDropdown: ({ confirm, setSelectedKeys, clearFilters }) => (
        <TableFilterInput
          placeholder="컨텐츠 번호"
          setSelectedKeys={setSelectedKeys}
          clearFilters={clearFilters}
          confirm={confirm}
        />
      ),
      render: (value, record) =>
        record.type === TAG_TAB_MAIN_CONTENTS_TYPE.PRODUCT ? (
          <OpenProductDetail text={value} productId={value} />
        ) : (
          <OpenReviewDetail text={value} reviewId={value} />
        ),
    },
    {
      title: <TableColumnTitle title={'상품명'} />,
      dataIndex: 'productName',
      className: !isFilter && 'not-filter',
      onFilter: (value, record) => record['productName'].toString().toLowerCase().includes(value.toLowerCase()),
      filterDropdown: ({ confirm, setSelectedKeys, clearFilters }) => (
        <TableFilterInput
          placeholder="상품명"
          setSelectedKeys={setSelectedKeys}
          clearFilters={clearFilters}
          confirm={confirm}
        />
      ),
    },
    {
      title: <TableColumnTitle title={'상태'} />,
      dataIndex: 'status',
      render: (value, record) =>
        record.type === TAG_TAB_MAIN_CONTENTS_TYPE.PRODUCT ? PRODUCT_STATUS_TEXT[value] : REVIEW_STATUS_TEXT[value],
    },
    {
      title: <TableColumnTitle title={'생성일'} />,
      dataIndex: 'createDate',
      render: (value) => setDateFormat(value),
    },
  ];
};
